import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const logoUrl = 'https://customer-assets.emergentagent.com/job_hugo-sites-pro/artifacts/hheqy0jw_logo.png';

  const handleWhatsAppClick = () => {
    const phone = '5521976614158';
    const message = 'Olá Hugo! Gostaria de falar sobre meu projeto.';
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <footer className="bg-gray-900 text-white py-16" role="contentinfo">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={logoUrl}
                alt="Hugo Renzi - Landing Pages Profissionais"
                className="h-10 w-auto brightness-0 invert"
                loading="lazy"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Especialista em presença digital com mais de 10 anos de experiência. 
              Transformando negócios através de landing pages profissionais e estratégicas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Sobre
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('servicos')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Planos
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-blue-400 transition-colors"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400">
                <Phone size={18} className="text-blue-400" aria-hidden="true" />
                <a href="tel:+5521976614158" className="hover:text-white transition-colors">
                  (21) 97661-4158
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Mail size={18} className="text-blue-400" aria-hidden="true" />
                <a href="mailto:contato@hugorenzi.com" className="hover:text-white transition-colors">
                  contato@hugorenzi.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <MapPin size={18} className="text-blue-400" aria-hidden="true" />
                <span>Curitiba, PR</span>
              </li>
            </ul>
            <button
              onClick={handleWhatsAppClick}
              className="mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:scale-105 w-full"
              aria-label="Falar no WhatsApp"
            >
              Falar no WhatsApp
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 Hugo Renzi. Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
